<template>
    <Card :title="status === 'add' ? '新增排污企业' : '修改排污企业'" style="position: absolute;right: 1rem;z-index:11;width: 50vw;">
        <div class="body">
          <a-form
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 14 }"
            :colon="false"
            :form="form"
            @submit="handleSubmit"
          >
            <a-row>
              <a-col :lg="24" :md="24" :sm="24">
                  <InputField labelWidth="12%" style="margin: 0.5rem 0.3rem;" label="企业名称" type="text" id="name" v-model="detail.name" required placeholder="企业名称"/>
              </a-col>

              <a-col :lg="12" :md="12" :sm="24">
                  <InputField labelWidth="30%" style="margin: 0.5rem 0.3rem;" label="法人" type="text" id="legalPerson" v-model="detail.legalPerson" placeholder="法人"/>
              </a-col>

              <a-col :lg="12" :md="12" :sm="24">
                  <InputField labelWidth="30%" style="margin: 0.5rem 0.3rem;" label="位置" type="text" id="location" v-model="detail.location" placeholder="位置"/>
              </a-col>

              <a-col :lg="12" :md="12" :sm="24">
                  <InputField labelWidth="30%" style="margin: 0.5rem 0.3rem;" label="经度" type="text" id="legalPerson" v-model="detail.x" required placeholder="经度"/>
              </a-col>

              <a-col :lg="12" :md="12" :sm="24">
                  <InputField labelWidth="30%" style="margin: 0.5rem 0.3rem;" label="纬度" type="text" id="legalPerson" v-model="detail.y" required placeholder="纬度"/>
              </a-col>

              <a-col :lg="12" :md="12" :sm="24">
                  <SelectField labelWidth="34%" style="margin: 0.5rem 0.3rem;" label="水质监测箱" required :options="waterqualityList" v-model="detail.deviceId" id="deviceId" placeholder="水质监测箱"/>
              </a-col>

              <a-col :lg="12" :md="12" :sm="24">
                  <RadioField labelWidth="25%" style="margin: 0.5rem 0.3rem;" label="企业状态" name="type" :options="statusList" v-model="detail.status"/>
              </a-col>
            </a-row>

            <div class="center">
              <a-space style="margin: 1rem">
                  <ButtonField text="取消" @click="cancel" secondary />
                  <ButtonField text="保存" primary @click="handleSubmit"/>
                  <ButtonField v-if="status === 'edit'" text="删除" @click="remove" secondary />
              </a-space>
            </div>
          </a-form>
        </div>
    </Card>
</template>
  
<script>
import request from "@/api/request";

function addRequest(data) {
  return request({
    url: "/model-analysis/pipe/sewageDischarger/save",
    method: "post",
    data,
  });
}

function editRequest(data) {
  return request({
    url: "/model-analysis/pipe/sewageDischarger/modify",
    method: "post",
    data,
  });
}

function removeRequest(data) {
  return request({
    url: "/model-analysis/pipe/sewageDischarger/delete/" + data.id,
    method: "post",
  });
}

export default {
  props: {
    status: {
      type: String,
    },

    waterqualityList: {
      type: Array,
      default: () => [],
    },

    selectedWaterQuality: {
      type: Object,
    },
    selectedLnglat: {
      type: Object,
    },

    detail: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      statusList:[{value: 1,name: '正常'},{value: 0,name: '禁用'}]
    };
  },

  watch: {
    selectedWaterQuality() {
      if (this.selectedWaterQuality.id) {
        this.form.setFieldsValue({
          deviceId: this.selectedWaterQuality.id,
        });
      }
    },
    selectedLnglat() {
      if (this.selectedLnglat.lng) {
        this.form.setFieldsValue({
          x: this.selectedLnglat.lng,
          y: this.selectedLnglat.lat,
        });
      }
    },
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("values", values);

          this.loading = true;

          if (this.status === "add") {
            addRequest({
              ...values,
            })
              .then(async () => {
                this.cancel();
                this.$emit("refresh");
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            editRequest({
              id: this.detail.id,
              ...values,
            })
              .then(async () => {
                this.cancel();
                this.$emit("refresh");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },

    cancel() {
      this.$emit("cancel");
    },

    remove() {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          removeRequest({
            id: that.detail.id,
          }).then(() => {
            that.cancel();
            that.$emit("refresh");
          });
        },
      });
    },
  },
};
</script>
  
  
<style lang="less" scoped>
.item {
  border-bottom: 1px solid #f0f0f0;
  padding: 2vh;
  margin-bottom: 2vh;

  .title {
    font-weight: bold;
    color: var(--theme-color);
    margin-bottom: 1vh;
  }


}
</style>